import { MantineProvider } from '@mantine/core';
import { useMemo } from 'react';
import { DisplayApp } from './display/DisplayApp.js';
import { LandingScreen } from './LandingScreen.js';
import { PlayerApp } from './player/PlayerApp.js';
import { parseRoute } from './routing.js';
import { cssVariablesResolver, displayTheme, playerTheme } from './theme.js';

export function App(): React.ReactElement {
  // URL は起動時に一度だけ読む。画面遷移は location.assign による再読み込みで行う。
  const route = useMemo(() => parseRoute(globalThis.location.search), []);

  if (route.kind === 'display') {
    return (
      <MantineProvider
        theme={displayTheme}
        defaultColorScheme="dark"
        forceColorScheme="dark"
        cssVariablesResolver={cssVariablesResolver}
      >
        <DisplayApp roomCode={route.roomCode} />
      </MantineProvider>
    );
  }

  return (
    <MantineProvider
      theme={playerTheme}
      defaultColorScheme="dark"
      forceColorScheme="dark"
      cssVariablesResolver={cssVariablesResolver}
    >
      {route.kind === 'player' ? <PlayerApp roomCode={route.roomCode} /> : <LandingScreen />}
    </MantineProvider>
  );
}
